exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.stat-value {\n    letter-spacing: -2px;\n    height: 42px;\n    line-height: 48px;\n    font-size: 30px;\n}\n.stat-label {\n    letter-spacing: -0.5px;\n    color: #b0bb81;\n    margin-top: -7px;\n    font-size: 16px;\n}\n", ""]);

// exports
